import { useRef, useState } from 'react';
import { useCursorTooltipPosition } from './lib/useCursorTooltipPosition';
import { useTooltipPosition } from './lib/useTooltipPosition';
import { useTooltipLeaveGuard } from './lib/useTooltipLeaveGuard';
import { TooltipPopup } from './components/TooltipPopup';
import { TooltipTrigger } from './components/TooltipTrigger';

export function Tooltip({
  content,
  children,
  placement = 'top',
  bubbleAlign = 'center',
  arrowOffsetPx = 12,
  arrowAlign = 'center',
  arrowWidthPx = 15,
  arrowHeightPx = 9,
  wrap = 'nowrap',
  bubbleMaxWidthPreset,
  bubbleWidthPx,
  bubbleMaxWidthPx,
  followCursor = false,
  showArrow = true,
  triggerClassName,
  openDelayMs = 0,
  contentKey,
}) {
  const triggerRef = useRef(null);
  const popupRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [cursor, setCursor] = useState({
    x: 0,
    y: 0,
  });
  const pos = useTooltipPosition({
    open: open && !followCursor,
    triggerRef,
    popupRef,
    placement,
    bubbleAlign,
    arrowOffsetPx,
    arrowAlign,
    arrowWidthPx,
  });

  const cursorPos = useCursorTooltipPosition({
    open: open && followCursor,
    popupRef,
    cursor,
  });

  useTooltipLeaveGuard({ open, triggerRef, onClose: () => setOpen(false) });

  if (!content && !triggerClassName) return children;

  return (
    <TooltipTrigger
      triggerRef={triggerRef}
      triggerClassName={triggerClassName}
      followCursor={followCursor}
      openDelayMs={openDelayMs}
      setOpen={setOpen}
      setCursor={setCursor}
    >
      {children}
      {open && content ? (
        <TooltipPopup
          key={contentKey}
          popupRef={popupRef}
          content={content}
          wrap={wrap}
          bubbleMaxWidthPreset={bubbleMaxWidthPreset}
          showArrow={showArrow}
          arrowWidthPx={arrowWidthPx}
          arrowHeightPx={arrowHeightPx}
          bubbleWidthPx={bubbleWidthPx}
          bubbleMaxWidthPx={bubbleMaxWidthPx}
          left={followCursor ? cursorPos.left : pos.left}
          top={followCursor ? cursorPos.top : pos.top}
          arrowLeft={pos.arrowLeft}
          ready={followCursor || pos.ready}
        />
      ) : null}
    </TooltipTrigger>
  );
}
